<ng-container *ngIf="!loading; else loadingTmp">
  <div *ngIf="leads.size > 0; else noData" class="kanban-container">
    <div class="kanban-graphics">
      <app-kanban-graphics [leads]="leadList"></app-kanban-graphics>
    </div>

    <div class="kanban">
      <app-kanban-column
        *ngFor="let group of leadList; trackBy: trackByGroup"
        [title]="group.column"
        [status]="group.column"
        [leads]="group.leads"
        [connectedTo]="dropListIds"
        (moved)="onMoved($event)"
      ></app-kanban-column>
    </div>
  </div>
</ng-container>

<ng-template #loadingTmp>
  <app-loading></app-loading>
</ng-template>

<ng-template #noData>
  <div>
    <h3>Você ainda não possui nenhuma oportunidade registrada.</h3>
  </div>
</ng-template>
